import React, { useRef, useState } from 'react';
import ENUMS from '../../../enums';
import DatePicker from './../../../components/FormElements/DatePicker/DatePicker';
import { Tooltip } from 'reactstrap';
import { useSelector } from 'react-redux';

const ReportListFilter = props => {
  const formRefrence = useRef();
  const { meInfo } = useSelector(state => ({
    meInfo: state.authReducer.meInfo,
  }));
  const { applyFilters } = props;
  const [btnClicked, setBtnClicked] = useState('');
  const [name, setName] = useState('');
  const [tableNum, setTableNum] = useState('');
  const [fromTime, setFromTime] = useState('');
  const [toTime, setToTime] = useState('');
  const [fromDate, setFromDate] = useState(' ');
  const [toDate, setToDate] = useState(' ');
  const [tooltipNameOpen, setTooltipNameOpen] = useState(false);

  const toggleName = () => setTooltipNameOpen(!tooltipNameOpen);

  const resetForm = event => {
    Array.from(formRefrence.current).forEach(element => {
      if (element.name === 'resetButton') {
        element.value = locales('fields.reset');
      } else {
        element.value = null;
      }
    });
    setName('');
    setTableNum('');
    setFromTime('');
    setFromDate(' ');
    setToDate(' ');
    setToTime('');
    applyFilters(event);
  };

  return (
    <article>
      <form
        onReset={event => resetForm(event)}
        onSubmit={event => applyFilters(event, btnClicked)}
        id='form'
        ref={formRefrence}
        className='my-4'
      >
        <main className='card-body'>
          <div className='row '>
            {meInfo.selectedRole.type === 'ADMIN' && (
              <div className='col-4'>
                <label className='col-12 text-right filter-field-label'>
                  {locales('fields.cafe.name')}
                </label>
                <input
                  name='cafeNamePart'
                  type='text'
                  value={name}
                  onChange={event => setName(event.target.value)}
                  className='form-control col-12'
                  placeholder={locales('fields.cafe.name')}
                  maxLength={ENUMS.MAX_LENGTH.cafeName}
                  id='cafeNamePart'
                />
                <Tooltip
                  placement='top-start'
                  isOpen={tooltipNameOpen}
                  target='cafeNamePart'
                  toggle={toggleName}
                >
                  {locales('maxLength.50')}
                </Tooltip>
              </div>
            )}

            <div className='col-4'>
              <label className='col-12 text-right filter-field-label'>
                {locales('fields.startDate')}
              </label>
              <DatePicker
                placeholder='تاریخ شروع'
                marge={true}
                name='fromDate'
                onChange={d => setFromDate(d)}
                value={fromDate}
                className='col-sm-12 col-md-6 date-picker-input'
              />
            </div>
            <div className='col-4'>
              <label className='col-12 text-right filter-field-label'>
                {locales('fields.endDate')}
              </label>
              <DatePicker
                placeholder='تاریخ پایان'
                marge={true}
                name='toDate'
                onChange={d => setToDate(d)}
                value={toDate}
                className='col-sm-12 col-md-6 date-picker-input'
              />
            </div>
            <div className='col-4'>
              <label className='col-12 text-right filter-field-label'>
                {locales('fields.table.no')}
              </label>
              <input
                name='tableNum'
                type='text'
                value={tableNum}
                onChange={event => setTableNum(event.target.value)}
                className='form-control col-12'
                placeholder={locales('fields.table.no')}
                maxLength={ENUMS.MAX_LENGTH.cafeName}
                id='tableNum'
              />
            </div>
            <div className='col-4'>
              <label className='col-12 text-right filter-field-label'>
                {locales('fields.reserve.start.date')}
              </label>
              <input
                name='fromTime'
                type='text'
                value={fromTime}
                onChange={event => setFromTime(event.target.value)}
                className='form-control col-12'
                placeholder={locales('fields.reserve.start.date')}
                maxLength={ENUMS.MAX_LENGTH.cafeName}
                id='fromTime'
              />
            </div>
            <div className='col-4'>
              <label className='col-12 text-right filter-field-label'>
                {locales('fields.reserve.end.date')}
              </label>
              <input
                name='toTime'
                type='text'
                value={toTime}
                onChange={event => setToTime(event.target.value)}
                className='form-control col-12'
                placeholder={locales('fields.reserve.end.date')}
                maxLength={ENUMS.MAX_LENGTH.cafeName}
                id='toTime'
              />
            </div>
          </div>
          <div className='col-12 d-flex justify-content-end p-0 pt-4'>
            <input
              name='resetButton'
              type='reset'
              value={locales('fields.reset')}
              className='btn btn-danger w-5 mx-2'
              maxLength='10'
            />
            <button
              type='submit'
              id='apply-filter-btn-cafe'
              className='btn btn-success w-5 mx-2'
              name='filter'
              onClick={() => setBtnClicked('filter')}
            >
              {locales('fields.applyFilters')}
            </button>
          </div>
        </main>
      </form>
    </article>
  );
};

export default ReportListFilter;
